import { defineStore } from 'pinia';
import type { MenuItem } from './menu.interface';

export const useMenuStore = defineStore('menu', {
  state: () => ({
    menu: <MenuItem[]>[],
  }),
  actions: {
    setMenu(role: string) {
      if (role === 'user') {
        this.menu = [
          /*  {
            label: 'Panel de control',
            to: '/',
            iconColor: 'primary',
            iconName: 'o_dashboard',
          }, */
          {
            id: 'W1',
            label: 'Inbox',
            iconColor: 'primary',
            iconName: 'mdi-inbox',
            to: '/workflow-instances',
          },
          {
            id: 'W4',
            label: 'Nueva solicitud',
            iconColor: 'primary',
            iconName: 'mdi-file-document-arrow-right-outline',
            to: '/new-request',
          },
          {
            id: 'W2',
            label: 'Mis tareas',
            iconColor: 'primary',
            iconName: 'mdi-clipboard-list-outline',
            to: '/active-tasks',
          },
          {
            id: 'W3',
            label: 'Mis solicitudes',
            iconColor: 'primary',
            iconName: 'mdi-send',
            to: '/my-requests',
          },
          /* {
            id: 'W2',
            label: 'Mis solicitudes',
            iconColor: 'primary',
            iconName: 'mdi-file-document-arrow-right-outline',
            to: '/formats/F-AC-02/',
          }, */
        ];
      } else if (role === 'admin') {
        this.menu = [
          /* {
            label: 'Panel de control',
            to: '/',
            iconColor: 'primary',
            iconName: 'o_dashboard',
          }, */
          {
            id: 'W2',
            label: 'Overview',
            to: '/overview',
            iconName: 'mdi-view-dashboard',
            iconColor: 'primary',
          },
          {
            id: 'W1',
            label: 'Workflows',
            to: '/workflows',
            // iconName: 'mdi-lan',
            iconName: 'mdi-vector-polyline',
            iconColor: 'primary',
          },
        ];
      }
    },
  },
});
